import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import { getUserDetails } from "../../features/userSlice";
import { checkSession } from "../../features/loginSlice";

const Profile = () => {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.user.userDetails);
  const currentUser = useSelector((state) => state.login.currentUser);

  useEffect(() => {
    dispatch(getUserDetails());
    dispatch(checkSession());
  }, [dispatch]);

  const name = currentUser?.name || userDetails?.name || "—";
  const email = currentUser?.email || userDetails?.email || "—";
  const role =
    currentUser?.role?.name ||
    currentUser?.role_name ||
    userDetails?.role ||
    "—";

  return (
    <div id="main" className="main">
      <Breadcrumb page="My Profile" />
      <section className="section">
        <div className="row">
          <div className="col-lg-8">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">My Profile</h5>
                <div className="row mb-3">
                  <div className="col-sm-3 fw-semibold">Name</div>
                  <div className="col-sm-9">{name}</div>
                </div>
                <div className="row mb-3">
                  <div className="col-sm-3 fw-semibold">Email</div>
                  <div className="col-sm-9">{email}</div>
                </div>
                <div className="row mb-3">
                  <div className="col-sm-3 fw-semibold">Role</div>
                  <div className="col-sm-9">{role}</div>
                </div>
                <Link to="/settings" className="btn btn-outline-primary btn-sm">
                  Account Settings
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Profile;
